import _ from 'lodash';
import moment from 'moment';
import { StyledColorIndicator, StyledTooltipTitle } from './Tooltip.style';
import { StyledLink } from '../../../ResourceAllocationOverview.style';

const TooltipTitle = ({ event, pointData }) => {
  const pointKey = _.get(pointData, 'key') || '';
  const pointName = _.get(pointData, 'name') || '';
  const url = _.get(pointData, 'url');
  const color = _.get(event, 'color');

  const year = moment(_.get(pointData, 'end_period')).format('YYYY');
  const startPeriod = moment(_.get(pointData, 'start_period')).format('MMM DD');
  const endPeriod = moment(_.get(pointData, 'end_period')).format('MMM DD');
  const periodDurationText = `${startPeriod} - ${endPeriod} ${year}`;

  const pointNameInView =
    pointKey === pointName ? pointKey : `${pointKey} ${pointName}`;

  return (
    <StyledTooltipTitle data-cy='tooltip-title'>
      <div className='primary'>{periodDurationText}:</div>
      <div className='secondary'>
        {url ? (
          <StyledLink href={url} target='_blank'>
            {pointNameInView}
          </StyledLink>
        ) : (
          <span>{pointNameInView}</span>
        )}
      </div>
      <StyledColorIndicator color={color} />
    </StyledTooltipTitle>
  );
};

export default TooltipTitle;
